document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".my-carousel-track");
  const prevBtn = document.querySelector(".carousel-btn.prev");
  const nextBtn = document.querySelector(".carousel-btn.next");
  const items = Array.from(track.querySelectorAll(".carousel-item"));

  let currentTranslate = 0;
  let isDragging = false;
  let startX = 0;
  let prevTranslate = 0;
  let movedDistance = 0;
  let velocity = 0;
  let isDragAction = false; // ←クリックとドラッグの判定用

  function getItemWidth() {
    const style = getComputedStyle(items[0]);
    return items[0].offsetWidth + parseInt(style.marginRight);
  }

  function getMinTranslate() {
    const wrapperWidth = track.parentElement.offsetWidth;
    const contentWidth =
      getItemWidth() * items.length -
      parseInt(getComputedStyle(items[items.length - 1]).marginRight);
    return wrapperWidth - contentWidth;
  }

  function setTranslate(x, transition = true) {
    track.style.transition = transition ? "transform 0.35s ease" : "none";
    currentTranslate = x;
    track.style.transform = `translateX(${x}px)`;
  }

  // -------------------------
  // ボタン操作
  // -------------------------
  prevBtn.addEventListener("click", () => {
    setTranslate(Math.min(currentTranslate + getItemWidth(), 0));
  });

  nextBtn.addEventListener("click", () => {
    setTranslate(Math.max(currentTranslate - getItemWidth(), getMinTranslate()));
  });

  // 画像ドラッグ禁止
  track.querySelectorAll("img").forEach(img =>
    img.addEventListener("dragstart", e => e.preventDefault())
  );

  // -------------------------
  // ドラッグ開始
  // -------------------------
  function dragStart(e) {
    isDragging = true;
    isDragAction = false;
    movedDistance = 0;

    startX = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    prevTranslate = currentTranslate;
    velocity = 0;

    track.style.transition = "none";
  }

  track.addEventListener("mousedown", dragStart);
  track.addEventListener("touchstart", dragStart, { passive: true });

  // -------------------------
  // ドラッグ中
  // -------------------------
  function dragMove(e) {
    if (!isDragging) return;

    const currentX = e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    const deltaX = currentX - startX;

    if (Math.abs(deltaX) > 4) {
      isDragAction = true; // ←ドラッグ判定 ON
    }

    movedDistance += Math.abs(deltaX);

    const maxT = 0;
    const minT = getMinTranslate();
    const nextPos = prevTranslate + deltaX;

    let adjustedDeltaX = deltaX;

    if (nextPos > maxT) {
      adjustedDeltaX = (nextPos - maxT) * 0.25;
    } else if (nextPos < minT) {
      adjustedDeltaX = (nextPos - minT) * 0.25;
    }

    currentTranslate = prevTranslate + adjustedDeltaX;
    track.style.transform = `translateX(${currentTranslate}px)`;

    velocity = adjustedDeltaX / 64;
  }

  track.addEventListener("mousemove", dragMove);
  track.addEventListener("touchmove", dragMove, { passive: false });

  // -------------------------
  // ドラッグ終了
  // -------------------------
  function dragEnd() {
    if (!isDragging) return;
    isDragging = false;

    requestAnimationFrame(inertia);
  }

  track.addEventListener("mouseup", dragEnd);
  track.addEventListener("mouseleave", dragEnd);
  track.addEventListener("touchend", dragEnd);

  // -------------------------
  // 慣性スクロール
  // -------------------------
  function inertia() {
    const maxT = 0;
    const minT = getMinTranslate();

    velocity *= 0.94;
    currentTranslate += velocity * 16;

    if (currentTranslate > maxT) {
      currentTranslate = maxT + (currentTranslate - maxT) * 0.25;
      velocity *= 0.7;
    } else if (currentTranslate < minT) {
      currentTranslate = minT + (currentTranslate - minT) * 0.25;
      velocity *= 0.7;
    }

    track.style.transform = `translateX(${currentTranslate}px)`;

    if (Math.abs(velocity) > 0.05) {
      requestAnimationFrame(inertia);
    } else {
      track.style.transition = "transform 0.25s ease-out";
      track.style.transform = `translateX(${currentTranslate}px)`;
    }
  }

  // -------------------------
  // クリック時の誤動作防止
  // -------------------------
  track.addEventListener("click", function (e) {
    if (isDragAction) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // -------------------------
  // リサイズ補正
  // -------------------------
  window.addEventListener("resize", () => {
    const max = 0;
    const min = getMinTranslate();

    currentTranslate = Math.max(Math.min(currentTranslate, max), min);
    track.style.transition = "none";
    track.style.transform = `translateX(${currentTranslate}px)`;
  });
});